import { Observable } from 'rxjs';

import { User } from '../user';
import { Message } from '../message';
import { Request } from '../request';

export interface Group {
  id: string;
  title: string;
  description?: string;
  users: User[];
  category: string;
  createdBy: User;
  banner?: string;
  anyoneCanAcceptRequest: boolean;
  anyoneCanModifyGroup: boolean;
  approveNewUsers: boolean;
  token?: string;
  createdAt: Date;
  updatedAt: Date;

  // Constructed on UI for list.
  usersMap?: { [key: string]: User };
  hasUnread$?: Observable<boolean>;
  hasUnread?: boolean;
  lastMessage$: Observable<Message>;
  lastMessage?: Message;
  messages$?: Observable<Message[]>;
  lastMessageReceivedAt?: Date;
  requests?: Request[];
}

export function createGroup(params: Partial<Group>) {
  return {} as Group;
}
